import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
    headerComponent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1rem',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            gap: 10,
        },
    },
    creditScore: {
        border: '1px solid #005eb2',
        padding: 5,
        borderRadius: 8,
    },
    documentItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
    },
    docName: {
        wordBreak: 'break-all',
    },
    crmLogo: {
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
        },
    },
    cardIconNote: {
        border: '1px solid #005EB2',
        backgroundColor: '#bcdae6',
        borderRadius: '50px',
        fontSize: 30,
        color: '#005EB2',
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
        },
    },
    userData: {
        display: 'flex',
        textAlign: 'justify',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
            display: 'block',
        },
    },
    actionbtn: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    hr: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        [theme.breakpoints.up('md')]: {
            width: '93%',
        },
        [theme.breakpoints.down('lg')]: {
            width: '91%',
        },
    },
    hrEmail: {
        width: '100%',
        color: localStorage.getItem('theme') === 'dark' ? 'white' : '#005eb2',
    },
    hrEmailBody: {
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            width: '78%',
        },
    },
    note: {
        marginLeft: theme.spacing(5),
        color: localStorage.getItem('theme') === 'dark' ? 'white' : '#005eb2',
        width: '91%',
        textAlign: 'justify',
        [theme.breakpoints.down('xs')]: {
            marginLeft: theme.spacing(1),
            textAlign: 'justify',
        },
    },
    docTitle: {
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        color: localStorage.getItem('theme') === 'dark' ? 'white' : '#005eb2',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'left',
        },
    },
    docs: {
        fontSize: 40,
        color: localStorage.getItem('theme') === 'dark' ? 'white' : '#005eb2',
    },
    card: {
        minHeight: 'auto',
        display: 'flex',
        padding: '8px',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
            minWidth: '100%',
            padiing: '8px',
        },
    },
    DropzoneDoc: {
        height: '190px',
        textAlign: 'center',
        padding: '20px',
        border: '3px dashed #eeeeee',
        backgroundColor: 'transparent',
        color: '#bdbdbd',
        marginBottom: '20px',
    },
    docWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        marginTop: '1.3rem',
    },
    placeholderDoc: {
        color: '#5F87AA',
    },
    btn: {
        fontSize: 12,
        color: '#fff',
        float: 'right',
        marginLeft: '3px',
        backgroundColor: '#005EB2',
    },
    field: {
        width: '100%',
        fontFamily: 'open sans',
    },
    placeholderDocIcon: {
        fontSize: 70,
        color: localStorage.getItem('theme') === 'dark' ? 'white' : '#005eb2',
        [theme.breakpoints.down('xs')]: {
            fontSize: 45,
        },
    },
    docBox: {
        width: '100%',
        overflow: 'auto',
        height: '100%',
        padding: 10,
        marginTop: '1rem',
    },
    endDiv: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
    },
    businessField: {
        marginTop: 10,
    },
    addressDiv: {
        display: 'flex',
        alignItems: 'center',
        gap: 5,
    },
    floorContainer: {
        marginTop: 10,
    },
    flexSpace: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    gItem1: {
        height: '84vh',
        overflow: 'auto',
        width: '100%',
        paddingRight: 10,
        [theme?.breakpoints?.down('md')]: {
            height: '70vh',
        },
    },
    galleryContainer: {
        height: '70vh',
        overflow: 'auto',
        width: '100%',
        paddingRight: 10,
        marginTop: 10,
        [theme?.breakpoints?.down('md')]: {
            height: '19vh',
        },
    },
    selections: {
        width: '100%',
        textAlign: 'end',
    },
    selection: {
        width: '100%',
    },
    commonAccordion: {
        display: 'block',
        height: 270,
        overflow: 'auto',
    },
    cloudIcon: {
        marginRight: 2,
        color: `${localStorage.getItem('theme') === 'dark' ? 'white' : '#005eb2'
            } !important`,
    },
    accordionDetail: {
        display: 'block',
        paddingTop: 0,
        overflow: 'auto',
        paddingTop: 5,
    },
    filterAccordian: {
        width: '100%',
        height: '70vh',
        overflow: 'auto',
    },
    fullWidth: {
        width: '100%',
    },
    textLabel: {
        zIndex: 0,
        color: 'hsl(0,0%,50%)',
        fontSize: '15px !important',
    },
    galleryContainerStyle: props => ({
        display: 'grid',
        gridTemplateColumns:
            props?.images?.length === 1
                ? 'none'
                : props?.floorPlanGallery || props?.isPublicPage
                    ? 'repeat(5, 1fr)'
                    : 'repeat(auto-fit, minmax(100px, 1fr))',
        justifyContent: props?.images?.length === 1 ? 'center' : 'initial',
        gap: '16px',
        [theme?.breakpoints?.down('sm')]: {
            gridTemplateColumns:
                props?.images?.length === 1
                    ? 'none'
                    : 'repeat(auto-fit, minmax(100px, 1fr))',
        },
    }),
    filterHeadFeature: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    filterFull: {
        height: '100%',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    filterSmall: {
        height: '100%',
        display: 'none',
        [theme.breakpoints.down('md')]: {
            display: 'block',
        },
    },
    filters: {
        marginBottom: 5,
    },
    filterBtnBox: {
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        justifyContent: 'center',
        width: '100%',
    },
    anchorTxt: {
        color: '#005eb2',
        cursor: 'pointer',
        fontWeight: 500,
    },
    dialogHeading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    transactionHeading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    pointer: {
        cursor: 'pointer',
    },
    dialogHeading2: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: 10,
        paddingLeft: 26,
    },
    orDiv: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    orTxt: {
        backgroundColor: '#e2edf5',
        width: 20,
        height: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        padding: 15,
    },
    comissionValue: {
        backgroundColor: '#e2edf5',
    },
    priceSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    priceS1: {
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    priceS2: {
        width: '20%',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    addressTxt: {
        fontSize: 16,
        fontWeight: 600,
    },
    summeryHead: {
        fontSize: 17,
    },
    dialogHead: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    dltBtn: {
        position: 'absolute',
        top: '5px',
        right: '5px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        padding: '5px',
        cursor: 'pointer',
        zIndex: 10,
        fontSize: 12,
        width: 20,
        height: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    contactText: {
        backgroundColor: '#e2edf5',
        color: '#000027',
        borderRadius: '14px',
        padding: '4px 7px 6px 7px',
        margin: '0px 3px',
    },
    Dropzone: {
        height: '123px',
        marginBottom: '30px',
        textAlign: 'center',
        padding: '17px',
        fontSize: 20,
        fontWeight: 500,
        borderRadius: 9,
        backgroundColor:
            localStorage.getItem('theme') === 'dark'
                ? 'transparent'
                : '#d9deeb !important',
        color:
            localStorage.getItem('theme') === 'dark'
                ? 'white'
                : '#5F87AA !important',
        border: '1.6px dashed #9faebc',
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            textAlign: 'center',
            padding: '17px',
            backgroundColor:
                localStorage.getItem('theme') === 'dark'
                    ? 'transparent'
                    : 'lightGray',
            color: localStorage.getItem('theme') === 'dark' ? 'white' : 'gray',
            border:
                localStorage.getItem('theme') === 'dark'
                    ? '1px dashed white'
                    : '',
            marginBottom: 5,
        },
    },
    spaceFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: 230,
    },
    uploadText: {
        margin: 0,
    },
    agreeBtnD: {
        backgroundColor: '#005eb2 !important',
        color: 'white !important',
        border: 'none !important',
        borderRadius: '7px !important',
        padding: '5px 10px !important',
    },
    headerBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 7,
    },
    gridView: {
        display: 'flex',
        gap: 10,
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
    },
    arrowBtn: {
        color: 'black',
        padding: 0,
    },
    dialogContent: {
        fontSize: 17,
    },
    sellerBtn: {
        backgroundColor: '#005eb2 !important',
        color: 'white !important',
        border: 'none !important',
        borderRadius: '12px !important',
        padding: '5px 10px !important',
        marginRight: 10,
    },
    agreeBtn: {
        backgroundColor: '#005eb2 !important',
        color: 'white !important',
        border: 'none !important',
        borderRadius: '7px !important',
        padding: '5px 10px !important',
        marginTop: 10,
    },
    disAgreeBtn: {
        backgroundColor: '#FF5C93 !important',
        color: 'white !important',
        border: 'none !important',
        borderRadius: '7px !important',
        padding: '5px 10px !important',
    },
    centerDiv: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        justifyContent: 'space-evenly',
    },
    flexBox: {
        display: 'flex',
        alignItems: 'center',
    },
    fieldBox: {
        width: '100%',
    },
    headingText: {
        marginBottom: 5,
        fontWeight: 600,
    },
    formControl: {
        marginLeft: 0,
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: 9,
    },
    inputlabel: {
        marginLeft: 15,
    },
    themeText: {
        color: localStorage.getItem('theme') === 'dark' ? 'white' : '#005eb2',
        fontSize: 15,
        width: '70%',
        wordBreak: 'break-all',
        [theme.breakpoints?.down('xs')]: {
            width: '100%',
        },
    },
    ContactClass: {
        background: '#3c46f5',
        color: '#fff',
        cursor: 'pointer',
        borderRadius: 5,
        marginRight: 10,
    },
    fieldContainer: {
        marginTop: '1rem',
        height: '92%',
    },
    avatarImg: {
        marginTop: '0px !important',
    },
    imgIcon: {
        position: 'absolute',
        backgroundColor: 'white',
        color: 'black',
        bottom: 0,
        fontSize: 22,
        borderRadius: 6,
        right: 0,
        cursor: 'pointer',
        zIndex: 2,
        [theme.breakpoints.down('xs')]: {
            fontSize: 28,
        },
    },
    featureDiv: {
        width: '100%',
        textAlign: 'end',
    },
    featureDiv2: {
        width: '100%',
        textAlign: 'end',
        paddingRight: 8,
    },
    transactionHead: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        marginBottom: 20,
    },
    accordianDetail: {
        borderTop: '2px solid rgb(188, 188, 188)',
        paddingTop: 10,
        height: '55vh',
        overflow: 'auto',
    },
    featureDivD: {
        width: '100%',
        textAlign: 'end',
        marginTop: '3rem',
    },
    gridBox: {
        height: '100%',
    },
    avatar: {
        width: theme.spacing(10),
        display: 'none',
        height: theme.spacing(10),
        backgroundColor: '#005EB2',
        marginTop: theme.spacing(2),
        fontSize: 32,
        fontWeight: 600,
        alignItems: 'center',
        aspectRatio: 'auto',
        [theme.breakpoints.down('xs')]: {
            padding: '5px',
            width: theme.spacing(14),
            height: theme.spacing(14),
        },
    },
    headerFeature: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    searchBtn: {
        padding: 0,
    },
    head: {
        marginBottom: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    headFilter: {
        marginBottom: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            marginTop: '1rem',
        },
    },
    filterBtn: {
        marginTop: 15,
    },
    filterHeading: {
        fontSize: 15,
    },
    filterAccordionWrapper: {
        height: '328px',
        overflow: 'auto',
    },
    filterBox: {
        padding: '20px 12px',
        border: '1px solid #c0bebe',
        height: '100%',
        marginRight: 6,
        [theme.breakpoints.down('md')]: {
            marginRight: 0,
        },
    },
    commonDropdown: {
        marginBottom: 5,
    },
    listBtn: {
        backgroundColor: '#e2edf5',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 16,
        padding: 15,
        height: 50,
        justifyContent: 'center',
    },
    listText: {
        fontSize: 16,
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#e2edf5',
        borderRadius: 16,
        height: 50,
    },
    listTextD: {
        fontSize: 20,
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#e2edf5',
        borderRadius: 16,
        padding: 10,
        height: 50,
    },
    listMenu: {
        margin: '2.5rem',
    },
    listMenuD: {
        marginTop: '5.3rem',
    },
    divider: {
        width: '100%',
    },
    headBtn: {
        display: 'flex',
        alignItems: 'center',
    },
    propertyFields: {
        padding: 20,
        marginTop: 10,
        height: '68vh',
        overflow: 'auto',
    },
    customPaper: {
        width: 400,
        [theme?.breakpoints?.down('sm')]: {
            width: '270',
        },
    },
    agentBtn: {
        marginTop: 10,
    },
    Paper: {
        position: 'relative',
        zIndex: 1,
        marginTop: '2%',
        width: `50%`,
        margin: 'auto',
    },
    cal: {
        width: '42%',
        height: 'auto',
        padding: 20,
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            padding: 15,
            width: '100%',
            height: 'auto',
        },
        boxShadow: 'none',
    },
    Dropzone: {
        height: '150px',
        marginBottom: '5px',
        textAlign: 'center',
        padding: '17px',
        backgroundColor: localStorage.getItem('theme') === 'dark' ? 'transparent' : 'lightGray',
        color: localStorage.getItem('theme') === 'dark' ? 'white' : 'gray',
        border: localStorage.getItem('theme') === 'dark' ? '1px dashed white' : '',
        [theme.breakpoints.down('md')]: {
            width: 250,
            textAlign: 'center',
            padding: '17px',
            backgroundColor: localStorage.getItem('theme') === 'dark' ? 'transparent' : 'lightGray',
            color: localStorage.getItem('theme') === 'dark' ? 'white' : 'gray',
            border: localStorage.getItem('theme') === 'dark' ? '1px dashed white' : '',
            marginBottom: 5,
        },
    },
    placeholderIcon: {
        fontSize: 50,
        [theme.breakpoints.down('xs')]: {
            fontSize: 45,
        },
    },
}));
